/**
 * A generic function that does nothing
 * @params args - any arguments
 */
// Test change. TODO: Remove aftter BADGER-986
var noop = function noop() {
  return;
};
export default noop;